export function validatePasswordChange(
  password: string,
  confirmation: string,
): string | null {
  if (password.length < 8) return "新密码至少需要 8 位";
  if (password !== confirmation) return "两次输入的新密码不一致";
  return null;
}
